import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { gripVerticalIcon } from 'components/global/Constant/Icons';

const VARIANT_TEXT_CLASS = {
  primary: 'text-primary',
  secondary: 'text-secondary',
  dark: 'text-secondary',
  light: 'text-white',
};

/**
 * HTML5 drag handle for reordering lists or sections. Pair with drop targets that
 * read the same `dataTransferType` and `itemId` via `dataTransfer.getData(type)`.
 *
 * @param {object} props
 * @param {string} props.itemId — stable id stored in dataTransfer (e.g. section key or row id)
 * @param {boolean} props.enabled — when false, renders nothing
 * @param {string} props.dataTransferType — MIME-like type string unique to this reorder surface
 * @param {'light'|'primary'|'secondary'|'dark'} [props.variant='light'] — icon/button color
 * @param {string} [props.ariaLabel='Drag to reorder'] — accessibility label for the handle
 * @param {string} [props.className] — extra classes on the button
 */
export function ReorderDragHandle({
  itemId,
  enabled,
  dataTransferType,
  variant = 'light',
  ariaLabel = 'Drag to reorder',
  className = '',
}) {
  if (!enabled) return null;
  const textClass = VARIANT_TEXT_CLASS[variant] ?? VARIANT_TEXT_CLASS.light;
  return (
    <button
      type="button"
      className={`btn btn-link ${textClass} p-0 mr-8 border-0 shadow-none text-decoration-none d-inline-flex align-items-center justify-content-center ${className}`.trim()}
      style={{ cursor: 'grab', lineHeight: 1, padding: '2px 4px' }}
      draggable
      aria-label={ariaLabel}
      onDragStart={(e) => {
        e.dataTransfer.setData(dataTransferType, itemId);
        e.dataTransfer.effectAllowed = 'move';
        e.stopPropagation();
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <FontAwesomeIcon
        icon={gripVerticalIcon}
        style={{ fontSize: '0.75rem', verticalAlign: 'middle' }}
        aria-hidden
      />
    </button>
  );
}

/**
 * Use in a drop zone’s `onDragOver` when allowing reorder-by-drop.
 * No-op when `allow` is false (leave event default so drops aren’t accepted).
 */
export function setReorderDragOverEffect(event, allow) {
  if (!allow) return;
  event.preventDefault();
  event.dataTransfer.dropEffect = 'move';
}
